

var reviewsTabLabel = 'Reviews';
var reviewsTargetId = 'judgeme_product_reviews';
var writeCommentBtnClass = 'jdgm-write-comment-btn';
var writeACommentLabel = "Write a Comment";
var writeReviewButtonSelector = '#judgeme_product_reviews button[data-testid="write-review-button"]';

function getReviewsTabButton() {
  var tabs = document.querySelectorAll('button[role="tab"]');
  var labelLower = reviewsTabLabel.toLowerCase();
  for (var i = 0; i < tabs.length; i++) {
    var tabText = tabs[i].textContent.trim().toLowerCase();
    if (tabText.indexOf(labelLower) !== -1) return tabs[i];
  }
  return null;
}

function scrollToReviews() {
  var target = document.getElementById(reviewsTargetId);
  if (target && typeof $s !== 'undefined' && $s.scrollToElement) $s.scrollToElement(target);
}

function handleBadgeClick(ev) {
  ev.preventDefault();
  ev.stopImmediatePropagation();
  var reviewsTab = getReviewsTabButton();
  var reviewsEl = document.getElementById(reviewsTargetId);
  if (!reviewsEl) {
    scrollToReviews();
    return;
  }
  if (!reviewsTab) {
    scrollToReviews();
    return;
  }
  if (reviewsTab.getAttribute('aria-selected') !== 'true') {
    reviewsTab.click();
    requestAnimationFrame(function() {
      requestAnimationFrame(scrollToReviews);
    });
  } else {
    scrollToReviews();
  }
}

function clickWriteReviewButton() {
  var btn = document.querySelector(writeReviewButtonSelector);
  if (btn) btn.click();
}

function handleWriteCommentClick(ev) {
  ev.preventDefault();
  ev.stopImmediatePropagation();
  var reviewsTab = getReviewsTabButton();
  var reviewsEl = document.getElementById(reviewsTargetId);
  if (!reviewsEl) {
    scrollToReviews();
    clickWriteReviewButton();
    return;
  }
  if (!reviewsTab) {
    scrollToReviews();
    clickWriteReviewButton();
    return;
  }
  if (reviewsTab.getAttribute('aria-selected') !== 'true') {
    reviewsTab.click();
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        scrollToReviews();
        requestAnimationFrame(clickWriteReviewButton);
      });
    });
  } else {
    scrollToReviews();
    requestAnimationFrame(clickWriteReviewButton);
  }
}

var badgeContainerClass = 'jdgm-prev-badge';

function attachBadgeListener(widget) {
  var badgeContainer = widget.querySelector('.' + badgeContainerClass);
  if (!badgeContainer) return false;

  var badge = badgeContainer.querySelector('.jdgm-prev-badge__text');
  if (badge && badge.dataset.jdgmCustomHandled !== 'true') {
    badge.dataset.jdgmCustomHandled = 'true';
    badge.addEventListener('click', handleBadgeClick, true);
  }

  if (badgeContainer.querySelector('.' + writeCommentBtnClass)) return true;
  var writeCommentBtn = document.createElement('button');
  writeCommentBtn.type = 'button';
  writeCommentBtn.className = writeCommentBtnClass;
  writeCommentBtn.textContent = writeACommentLabel;
  writeCommentBtn.addEventListener('click', handleWriteCommentClick, true);
  badgeContainer.appendChild(writeCommentBtn);
  return true;
}

var widgetHandledAttr = 'data-jdgm-write-comment-handled';

function processWidget(widget) {
  if (!widget || widget.getAttribute(widgetHandledAttr) === 'true') return;
  var attached = attachBadgeListener(widget);
  if (attached) widget.setAttribute(widgetHandledAttr, 'true');
}

function initJudgemeReviewsCustom() {
  var widgets = document.querySelectorAll('.jdgm-widget');
  for (var i = 0; i < widgets.length; i++) processWidget(widgets[i]);
}

var judgemeReviewsObserver = new MutationObserver(function(mutations) {
  for (var m = 0; m < mutations.length; m++) {
    var added = mutations[m].addedNodes;
    for (var i = 0; i < added.length; i++) {
      var node = added[i];
      if (node.nodeType !== 1) continue;
      if (node.classList && node.classList.contains('jdgm-widget')) processWidget(node);
      if (node.classList && node.classList.contains(badgeContainerClass)) {
        var widget = node.closest && node.closest('.jdgm-widget');
        if (widget) processWidget(widget);
      }
      var found = node.querySelectorAll && node.querySelectorAll('.jdgm-widget');
      if (found) for (var j = 0; j < found.length; j++) processWidget(found[j]);
    }
  }
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    initJudgemeReviewsCustom();
    judgemeReviewsObserver.observe(document.body, { childList: true, subtree: true });
  });
} else {
  initJudgemeReviewsCustom();
  judgemeReviewsObserver.observe(document.body, { childList: true, subtree: true });
}